import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motivosRechazo',
  templateUrl: './motivosRechazo.component.html',
  styleUrls: ['./motivosRechazo.component.scss']
})
export class MotivosRechazoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/motivosRechazo/motivosRechazo.component.ts